var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 0.273438H2.5C1.25781 0.273438 0.25 1.28125 0.25 2.52344C0.25 2.92188 0.578125 3.25 1 3.25C1.39844 3.25 1.75 2.89844 1.75 2.52344C1.75 2.10156 2.07812 1.77344 2.5 1.77344H5.03125C5.6875 1.77344 6.25 2.3125 6.25 2.96875C6.25 3.4375 5.99219 3.85938 5.52344 4.09375L3.22656 5.42969C2.99219 5.57031 2.875 5.80469 2.875 6.0625V7C2.875 7.42188 3.20312 7.75 3.625 7.75C4.02344 7.75 4.375 7.42188 4.375 7V6.50781L6.25 5.40625C7.16406 4.9375 7.75 4 7.75 2.96875C7.75 1.46875 6.53125 0.273438 5.03125 0.273438ZM3.625 8.875C3.08594 8.875 2.6875 9.29688 2.6875 9.8125C2.6875 10.3516 3.08594 10.75 3.625 10.75C4.14062 10.75 4.5625 10.3281 4.5625 9.8125C4.5625 9.32031 4.14062 8.875 3.625 8.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.098b2ed02f5161090863b6e56e6bf6dd.svg";
export { ForwardRef as ReactComponent };